import type { LineLayer } from 'react-map-gl';

export const deliveriesLineLayer: LineLayer = {
  id: 'deliveriesRoute',
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#4bc9b0',
    'line-width': 2,
  },
};

export const stopsLineLayer: LineLayer = {
  id: 'stopsRoute',
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#b02025',
    'line-width': 2,
  },
};

export const courierLineLayer: LineLayer = {
  id: 'courierRoute',
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#00e4ff',
    'line-width': 2,
  },
};

/**
 * One colour per planned route in the Capacity Planning Result tab; the colour
 * is carried by each feature so a single layer draws every route.
 */
export const capacityPlanRoutesLineLayer: LineLayer = {
  id: 'capacityPlanRoutes',
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': ['get', 'colour'],
    'line-width': 2,
  },
};
